<div class="d-flex flex-row gap-3">
  <div class="flex-fill">
    <label class="mb-1">
      {{ (mapping?.mappingType == MappingType.FieldSpecific ? 'Quell-Felder auswählen' : 'Ziel-Feld/er auswählen') | translate }}
      ({{ 'maximal 7 gleichzeitig auswählbar' | translate }}):
    </label>
    <dx-drop-down-box
        [(value)]="mapping.mappingFields"
        valueExpr="field"
        displayExpr="translatedField"
        [dataSource]="fieldListTree"
        fieldTemplate="fieldTemplate"
        contentTemplate="content">

      <div *dxTemplate="let _ of 'fieldTemplate'">
        <dx-tag-box
            [dataSource]="fieldListTree"
            valueExpr="field"
            displayExpr="translatedField"
            [(value)]="mapping.mappingFields"
            [openOnFieldClick]="false"
            [showClearButton]="false"
            tagTemplate="tagTemplate">
          <div *dxTemplate="let tag of 'tagTemplate'">
            <div class="dx-tag-content">
              <span>{{ tag?.translatedField ?? tag?.field ?? tag }}</span>
              <div class="dx-tag-remove-button" (click)="onRemoveField(tag?.field ?? tag, $event)"></div>
            </div>
          </div>
        </dx-tag-box>
      </div>

      <div *dxTemplate="let _ of 'content'">
        <dx-tree-view
            #tree
            [dataSource]="fieldListTree"
            dataStructure="plain"
            keyExpr="field"
            parentIdExpr="parentId"
            itemTemplate="treeItem"
            selectionMode="multiple"
            showCheckBoxesMode="none"
            [selectByClick]="false">

          <div *dxTemplate="let item of 'treeItem'">
            <div class="tree-row" [class.is-parent]="item.parentId == null">

              <ng-container *ngIf="item.parentId != null; else groupTpl">
                <div class="leaf-layout">
                  <dx-check-box
                      class="leaf-checkbox"
                      [disabled]="isLeafDisabled(item)"
                      [value]="isSelected(item)"
                      (onValueChanged)="onFieldSelectionChanged(item, $event)">
                  </dx-check-box>

                  <div class="tree-item is-leaf">
                    <div class="tree-item__code">{{ item.field }}</div>
                    <div class="tree-item__name">{{ item.translatedField }}</div>
                  </div>
                </div>
              </ng-container>

              <ng-template #groupTpl>
                <div class="tree-item is-parent">
                  <div class="tree-item__group">{{ item.translatedField }}</div>
                </div>
              </ng-template>

            </div>
          </div>
        </dx-tree-view>
      </div>
    </dx-drop-down-box>
  </div>
</div>

<div class="rows-wrapper" id="mappingGridWrapper">
  <dx-load-panel
      shadingColor="rgba(0,0,0,0.4)"
      [position]="{ of: '#mappingGridWrapper' }"
      [(visible)]="isLoading"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [hideOnOutsideClick]="false">
  </dx-load-panel>
  <dx-data-grid
      #mappingGrid
      height="100%"
      [dataSource]="mapping.fields"
      keyExpr="id"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      (onRowInserting)="onRowInserting($event)"
      (onSaved)="onSaveMappings()">
    <dxo-scrolling mode="standard" [useNative]="false"/>
    <dxo-paging [enabled]="false"/>
    <dxo-search-panel [visible]="true" [width]="240" placeholder="{{ 'Suchen' | translate }}"/>
    <dxo-filter-row [visible]="true"/>
    <dxo-header-filter [visible]="true"/>

    <dxo-editing
        mode="cell"
        [allowAdding]="true"
        [allowDeleting]="true"
        [allowUpdating]="true"
        [useIcons]="true">
      <dxo-texts
          confirmDeleteMessage="{{ 'Wollen Sie diesen Eintrag wirklich löschen' | translate }}?"
          confirmDeleteTitle="{{ 'Eintrag löschen' | translate }}"
          addRow="{{ 'Neuen Eintrag erstellen' | translate }}">
      </dxo-texts>
    </dxo-editing>

    <dxo-toolbar>
      <dxi-item name="addRowButton" location="before"/>
      <dxi-item name="searchPanel" location="after"/>
    </dxo-toolbar>

    <dxi-column dataField="key" [caption]="key" [allowEditing]="mapping.mappingType != MappingType.FieldSpecific"/>
    <dxi-column dataField="value" [caption]="value" [allowEditing]="true"/>
  </dx-data-grid>
</div>

<div class="d-flex flex-row justify-content-between gap-2 mt-2">
  <dx-button
      text="{{ 'Quellwerte aus Import Felder bestimmen' | translate }}"
      stylingMode="outlined"
      [disabled]="!activeCatalogId || !mapping.mappingFields?.length || isLoading"
      (onClick)="fillFromCatalog()">
  </dx-button>
  <dx-button
      class="golden-record-button"
      text="{{ 'Vorhandene Werte aus Golden Record übernehmen' | translate }}"
      stylingMode="contained"
      type="default"
      [disabled]="!mapping.mappingFields?.length || isLoading"
      (onClick)="fillValueFromGoldenRecord()">
  </dx-button>
</div>
